import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import _debounce from "lodash/debounce";
import EditThumbnailUploadInput from "../../../../../../parts/inputs/edit-thumbnail-upload";
import { S3 } from "../../../../../../constants";

export const EditLink = ({
  thumbnailProps,
  urlProps,
  imageProps,
  _idProps,
  widgetProps,
  locals,
  setEditLinkState,
}) => {
  const widgetLinkThumbnail = locals.widgetLinkThumbnail || "";

  const [editState, setEditState] = useState({
    //state to control the link's edit form
    thumbnail: thumbnailProps,
    url: urlProps || "",
    widget: widgetProps,
    image: imageProps,
    _id: _idProps,
  });

  const imageToShowEditing =
    thumbnailProps && !imageProps
      ? thumbnailProps
      : !thumbnailProps && imageProps
      ? S3.toCDN(imageProps.s3Path)
      : thumbnailProps && imageProps
      ? S3.toCDN(imageProps.s3Path)
      : {};

  const debounceFn = useCallback(_debounce(handleDebounceFn, 2000), []);

  const handleInputLinkChange = (event) => {
    const newState = Object.assign({}, editState, {
      [event.target.name]: event.target.value,
    });
    setEditState(newState);

    searchThumbnail(event);
  };

  /**
   * search thumbnail when user enter a url
   */
  const searchThumbnail = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const URL_REGEX =
      /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    if (!URL_REGEX.test(e.target.value)) {
      return;
    }

    debounceFn(e.target.value);
  };

  function handleDebounceFn(inputValue) {
    submit(`/actions/links/thumbnail`, {
      method: "POST",
      body: { url: inputValue },
    });
  }

  /**
   * Validate if edit form is valid
   * @returns
   */
  const validationLinkSubmit = () => {
    if (editState.url.length > 0) {
      return true;
    }
    return false;
  };

  const { t } = useTranslation("coaching-portal");

  return (
    <form
      encType="multipart/form-data"
      method="POST"
      data-noreset
      action={
        editState._id
          ? `/actions/links/save/${editState._id}`
          : "/actions/links/save/"
      }
      className="add-edit-store-wrapper"
    >
      <EditThumbnailUploadInput
        widgetLinkThumbnail={widgetLinkThumbnail}
        name="image"
        backgroundedit={imageToShowEditing}
      />
      <div>
        <div className="input-box">
          <label> {t("widgets.editLink.linkUrl")} </label>
          <input
            name="url"
            className="text-input"
            placeholder={t("widgets.editLink.pasteUrlPlaceholder")}
            value={editState.url}
            onChange={handleInputLinkChange}
          />
          <input
            name="widget"
            style={{ display: "none" }}
            defaultValue={editState.widget}
          />
          <input
            name="_id"
            style={{ display: "none" }}
            defaultValue={editState._id}
          />
        </div>
        <div className="flex flex-row gap-2">
          <button data-button-type="primary" disabled={!validationLinkSubmit()}>
            {t("widgets.common.save")}
          </button>
          <button
            data-button-type="text-white"
            data-action="cancel"
            onClick={(e) => {
              e.preventDefault();
              setEditLinkState("");
            }}
          >
            {t("widgets.common.cancel")}
          </button>
        </div>
      </div>
    </form>
  );
};
